import { render, staticRenderFns } from "./WithdrawalDetails.vue?vue&type=template&id=1489c3a8&scoped=true&"
import script from "./WithdrawalDetails.vue?vue&type=script&lang=js&"
export * from "./WithdrawalDetails.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalDetails.vue?vue&type=style&index=0&id=1489c3a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1489c3a8",
  null
  
)

export default component.exports